import React from 'react';
import { Container, Row } from 'react-bootstrap';
import { FaPhone, FaEnvelope } from 'react-icons/fa';
import Title from './SectionTitle';
import Item from './ServiceItem';
import { langPathSuffix } from '../lang-utils';

const SERVICE_SLUGS = [
  'motociklai',
  'automobiliai',
  'visureigiai',
  'mikroautobusai',
  'kita-technika',
  'kroviniai',
  'pagalba-kelyje',
  '247'
];

function serviceLink(slug, lang) {
  return `/paslaugos/${slug}/${langPathSuffix(lang)}`;
}

function Section(prop) {
  let scrollOffsetClass = '';
  if (prop.onTop && prop.pageWidth <= 990) {
    scrollOffsetClass = 'scroll-offset-fix';
  }
  const lang = prop.lang || 'lt';

  return (
    <div
      id="service"
      className={scrollOffsetClass}
      style={prop.section === 'dark' ? { backgroundColor: '#fef5dd' } : null}
    >
      <Container className="section-padding">
        {!prop.hideTitle && <Title title={prop.strings.service.sectionName} />}
        <div className="service-description">
          <div className="text-justify">{prop.strings.service.mainText}</div>
          <div className="text-center text-justify text-padding-top">
            {prop.strings.service.callmenow}:
          </div>
          <div className="text-center">
            <div className="fa-phone-270 inline"><FaPhone /></div>
            <div className="call-me inline">&nbsp; +&#51;&#55;&#48; 6&#55;304&#55;2&#55;</div>
          </div>
          <div className="text-center text-justify text-padding-top">
            {prop.strings.service.mailmenow}:
          </div>
          <div className="text-center">
            <div className="fa-mail-2 inline"><FaEnvelope /></div>
            <div className="call-me inline">&nbsp; kaunetraliukas&#64;&#103;&#109;ai&#108;.com</div>
          </div>
        </div>
        <Row>
          <Item
            link={serviceLink(SERVICE_SLUGS[0], lang)}
            photo="moto-t.png"
            alt={`${prop.strings.service.motocycleHeader} – ${prop.strings.service.motocycleText}`}
            title={prop.strings.service.motocycleHeader}
            description={prop.strings.service.motocycleText}
          />
          <Item
            link={serviceLink(SERVICE_SLUGS[1], lang)}
            photo="auto-b-t.png"
            alt={`${prop.strings.service.carHeader} – ${prop.strings.service.carText}`}
            title={prop.strings.service.carHeader}
            description={prop.strings.service.carText}
          />
          <Item
            link={serviceLink(SERVICE_SLUGS[2], lang)}
            photo="offroad-auto-t.png"
            alt={`${prop.strings.service.offroadHeader} – ${prop.strings.service.offroadText}`}
            title={prop.strings.service.offroadHeader}
            description={prop.strings.service.offroadText}
          />
          <Item
            link={serviceLink(SERVICE_SLUGS[3], lang)}
            photo="mikro-b-t.png"
            alt={`${prop.strings.service.busHeader} – ${prop.strings.service.busText}`}
            title={prop.strings.service.busHeader}
            description={prop.strings.service.busText}
          />
          <Item
            link={serviceLink(SERVICE_SLUGS[4], lang)}
            photo="other-b-t.png"
            alt={`${prop.strings.service.otherHeader} – ${prop.strings.service.otherText}`}
            title={prop.strings.service.otherHeader}
            description={prop.strings.service.otherText}
          />
          <Item
            link={serviceLink(SERVICE_SLUGS[5], lang)}
            photo="other-2-b-t.png"
            alt={`${prop.strings.service.goodsHeader} – ${prop.strings.service.goodsText}`}
            title={prop.strings.service.goodsHeader}
            description={prop.strings.service.goodsText}
          />
          <Item
            link={serviceLink(SERVICE_SLUGS[6], lang)}
            photo="sos-t.png"
            alt={`${prop.strings.service.emergencyHeader} – ${prop.strings.service.emergencyText}`}
            title={prop.strings.service.emergencyHeader}
            description={prop.strings.service.emergencyText}
          />
          <Item
            link={serviceLink(SERVICE_SLUGS[7], lang)}
            photo="247-t.png"
            alt={`${prop.strings.service.anyTimeHeader} – ${prop.strings.service.anyTimeText}`}
            title={prop.strings.service.anyTimeHeader}
            description={prop.strings.service.anyTimeText}
          />
        </Row>
      </Container>
    </div>
  );
}

export default Section;
